
const DiscountMinimumRequirementInput = {
  "name": "DiscountMinimumRequirementInput",
  "kind": "INPUT_OBJECT",
  "inputFieldBaseTypes": {
    "quantity": "DiscountMinimumQuantityInput",
    "subtotal": "DiscountMinimumSubtotalInput"
  }
};
export default DiscountMinimumRequirementInput;